import React, { useState } from 'react';
import { TextField } from '@cimpress/react-components';

const TextFieldExampleNumber = () => {
  const [text, setText] = useState('');

  const onInputChange = e => {
    setText(e.target.value);
  };

  return (
    <TextField
      name="number"
      label="Number text field between 0-10"
      value={text}
      onChange={e => onInputChange(e)}
      type="number"
      step="0.01"
      min="0"
      max="10"
    />
  );
};

export default TextFieldExampleNumber;
